import { Helmet } from "react-helmet";
import { useEffect, useContext } from "react";
import Context from "../../storage/context";

function PageWrapper({ title, page, children }) {
    let ctx = useContext(Context);
    useEffect(() => {
        ctx.setTabSelectedUser(page);
    }, [page]);
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <link rel="canonical" href={`https://roeicar.co.il${window.location.pathname}`} />
            </Helmet>
            {children}
        </>
    );
}

export default PageWrapper;
